export const ADD_DOCUMENT = 'ADD_DOCUMENT';
export const REMOVE_DOCUMENT = 'REMOVE_DOCUMENT';
export const REMOVE_ALL_DOCUMENTS = 'REMOVE_ALL_DOCUMENTS';
export const SET_DRAG_SOURCE = 'SET_DRAG_SOURCE';
export const SET_FOLDER_LIST = 'SET_FOLDER_LIST';
export const UPDATE_FOLDER_LIST = 'UPDATE_FOLDER_LIST';
export const SET_DOCUMENT_OVER_ID = 'SET_DOCUMENT_OVER_ID';
export const SET_FOLRED_OVER_ID = 'SET_FOLRED_OVER_ID';